// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5c3fad09","977":"1725b287"}[chunkId] + ".chunk.js";
};